import { toCompanyMoment } from "@/util/companyTime";

// Global fallback formatDate (most pages define their own). Final-version doc
// 2026-10-05: printed in Damascus time (fixed UTC+3), never in the viewer's
// PC zone. The company wall clock is carried as a UTC Date and Intl prints it
// with timeZone "UTC", so the long localized layout is kept.
export default {
    methods: {
      formatDate(dateString) {
        const company = toCompanyMoment(dateString);
        if (!company) {
          return "-";
        }
        const wall = new Date(
          company.valueOf() + company.utcOffset() * 60000
        );
        return new Intl.DateTimeFormat("default", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
          timeZone: "UTC",
        }).format(wall);
      },
    },
  };
